<header class="account-addresses-header">
  <h3 class="account-addresses-title">{{ 'my_addresses' | translate }}</h3>
</header>
<main class="account-addresses-main">
  <ng-container *ngIf="hasAddresses; else noAddresses">
    <div class="account-addresses-container">
      <account-address
        *ngFor="let address of addresses"
        [address]="address"
        (editAddress)="onEditAddress(address)"
        (deleteAddress)="onDeleteAddress(address)"
        [tabIndex]="0"
        [ariaLabel]="getAriaLabel(address)"
      ></account-address>
    </div>
  </ng-container>
  <ng-template #noAddresses>
    <div class="account-addresses-empty-state">
      <figure class="account-addresses-empty-state-image image contain-image">
        <img [src]="'/assets/images/general/vespa.svg'" [alt]="'box no addresses'" />
      </figure>
      <h5 class="account-addresses-empty-state-title">{{ 'where_should_we_deliver_it' | translate }}</h5>
      <p class="account-addresses-empty-state-subtitle ods-typography-body-s-bold">
        {{ 'insert_address_text' | translate }}
      </p>
      <button
        box-button
        theme="primary"
        type="button"
        class="account-addresses-empty-state-btn"
        (click)="onAddAddress()"
        [attr.aria-label]="'add_new_address' | translate"
      >
        {{ 'add_new_address' | translate }}
      </button>
    </div>
  </ng-template>
</main>
<footer *ngIf="hasAddresses" class="account-addresses-footer">
  <button
    box-button
    theme="secondary"
    type="button"
    class="account-addresses-btn"
    (click)="onAddAddress() "
    [attr.aria-label]="'add_new_address' | translate"
  >
    {{ 'add_new_address' | translate }}
  </button>
</footer>
